<template>
    <section class="bg-white">
        <div
            class="gap-8 items-center py-8 px-4 mx-auto max-w-screen-xl xl:gap-16 md:grid md:grid-cols-2 sm:py-16 lg:px-6">
            <img class="w-full rounded-lg" src="@/assets/images/quem-somos-img.webp"
                alt="Quantum Logo">
            <div class="mt-4 md:mt-0">
                <h2 class="mb-4 text-4xl tracking-tight font-extrabold text-gray-900">Quem Somos</h2>
                <p class="mb-6 font-light text-gray-500 md:text-lg">Mais de 20 Anos de Experiência em Películas

                    Com duas décadas de atuação, somos referência em películas para vidros, unindo qualidade, inovação e
                    desempenho. Oferecemos soluções para veículos e ambientes, garantindo mais conforto, proteção e
                    privacidade.</p>
                <router-link to="/about" class="inline-flex items-center text-blue-700 cursor-pointer hover:underline">
                    Conheça nossa História
                    <svg class="ml-2 -mr-1 w-5 h-5" fill="currentColor" viewBox="0 0 20 20"
                        xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd"
                            d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                            clip-rule="evenodd"></path>
                    </svg>
                </router-link>
            </div>
        </div>
    </section>
</template>

<script>
export default {

}
</script>

<style></style>